/**
 * Internal dependencies
 */
import cecSdk from 'lib/customer-ec-sdk';
import receiveLocations from './receive-locations';
import * as actions from 'state/action-types';

export default (locationId = null, location) => (dispatch) => {
    const isNew = !locationId;
    if (isNew) {
        return cecSdk
            .location()
            .add(location)
            .then((location) => {
                dispatch(receiveLocations([location]));
                dispatch({ type: actions.SAVE_LOCATION_SUCCESS, payload: { location, isNew } });
            });
    }

    return cecSdk
        .location(locationId)
        .update(location)
        .then((location) => {
            dispatch(receiveLocations([location]));
            dispatch({ type: actions.SAVE_LOCATION_SUCCESS, payload: { location } });
        });
};
